import { render, staticRenderFns } from "./PromotionRules.vue?vue&type=template&id=8b37fb70&scoped=true&"
import script from "./PromotionRules.vue?vue&type=script&lang=js&"
export * from "./PromotionRules.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRules.vue?vue&type=style&index=0&id=8b37fb70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b37fb70",
  null
  
)

export default component.exports